import { render } from "./MyPartnershipStakeList.vue?vue&type=template&id=24b13c81&ts=true"
import script from "./MyPartnershipStakeList.vue?vue&type=script&lang=ts"
export * from "./MyPartnershipStakeList.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__